import { render } from "./XeroSettingsView.vue?vue&type=template&id=547fed8c&scoped=true"
import script from "./XeroSettingsView.vue?vue&type=script&lang=js"
export * from "./XeroSettingsView.vue?vue&type=script&lang=js"

import "./XeroSettingsView.vue?vue&type=style&index=0&id=547fed8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547fed8c"]])

export default __exports__